module.exports = __webpack_public_path__ + "img/Dual_Polarization_Tower_Sketch.0579589c.png";